exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".title[data-v-b2aa1eec]{padding:10px;border-radius:10px;background-color:#f3f3f3}.circle[data-v-b2aa1eec]{padding:10px;border-radius:50%;background-color:#e8d3f7}.ag-tooltip-standar[data-v-b2aa1eec]{background-color:#fff;color:rgba(0,0,0,.87);padding:8px;border:none #e2e2e2;border-radius:2px;transition:opacity 1s;white-space:normal;box-shadow:5px 5px 10px rgba(0,0,0,.3)}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-b2aa1eec","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/empresas/components/TooltipDiagnosis.vue
// module id = 640
// module chunks = 2